module.exports = __webpack_public_path__ + "img/1.1f4d5211.png";